import type { GoalType } from "@/lib/api-types";

export const GOAL_TYPE_LABEL: Record<GoalType, string> = {
  study_minutes: "Study time",
  chapters_completed: "Chapters completed",
  quizzes_taken: "Quizzes taken",
  quiz_avg_percent: "Quiz average",
};

export function formatGoalValue(type: GoalType, value: number): string {
  if (type === "study_minutes") return `${value} min`;
  if (type === "quiz_avg_percent") return `${value}%`;
  return `${value}`;
}
